import { Component, OnInit } from '@angular/core';
import { RecSearchService } from '../../../rec-search/rec-search-service'
import { DocCatVM } from '../../viewmodels/ISearchService';

@Component({
  selector: 'app-doccategoryex',
  templateUrl: './doccategoryex.component.html',
  styleUrls: ['./doccategoryex.component.css']
})
export class DoccategoryexComponent implements OnInit {
  public docCategories: DocCatVM[];
  error: any;
  constructor(private service: RecSearchService) {

    this.getDocCategories();
  }

  ngOnInit() {
  }

  getDocCategories() {
    this.service.getDocCategories().subscribe(
      data => { this.docCategories = data }
      ,
      error => { this.error = error }


    );
  }

}
